import {GenericZoneEditEngine} from './generic-zone-edit-engine.class';
import * as mapboxgl from 'mapbox-gl';
import {Observable, of} from 'rxjs';
import {MapControlPanelAction} from './map-edit-engine.interface';
import {QGraph} from '../../interfaces/geo-and-movement.interfaces';
import {FormControl} from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';

export class DiscoveryEditEngine extends GenericZoneEditEngine {
  readonly uniqueId: string;
  discoveryPercentControl = new FormControl<number>(90);

  constructor(map: mapboxgl.Map,
              mapControlPanelAction$: Observable<MapControlPanelAction>,
              zone?: QGraph,
              callbackOnAnyClick?: (zoneEngine: GenericZoneEditEngine) => void) {
    const uid = uuidv4();
    map.addSource('discovery-zones-' + uid, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: []
      }
    });
    map.addLayer({
      id: 'discovery-zones-' + uid,
      type: 'fill',
      source: 'discovery-zones-' + uid,
      layout: {},
      paint: {
        'fill-color': '#6225ad',
        'fill-opacity': 0.3
      }
    });

    map.addLayer({
      id: 'discovery-zones-outline-' + uid,
      type: 'line',
      source: 'discovery-zones-' + uid,
      layout: {},
      paint: {
        'line-color': '#6225ad',
        'line-width': 2
      }
    });
    super(map, mapControlPanelAction$, 'discovery-zones-' + uid, 'discovery-zones-' + uid, true, undefined, zone, callbackOnAnyClick);
    this.uniqueId = uid;
    this.postInit();
  }

  getStrokeColor$(): Observable<string> {
    // this is used for vertices' markers colors
    return of('#6225ad');
  }

  override getData(): any {
    const data = super.getData();

    return {
      ...data,
      discoveryPercent: this.discoveryPercentControl.value
    }
  }

  override clear(): void {
    super.clear();
    this.discoveryPercentControl.setValue(90);
  }

  setDiscoveryPercent(value: number): void {
    if (!value) {
      value = 50;
    }

    if (value < 10) {
      value = 10;
    }

    if (value > 100) {
      value = 100;
    }

    this.discoveryPercentControl.setValue(value);
  }

  override destroy() {
    super.destroy();

    this.map.removeLayer('discovery-zones-' + this.uniqueId);
    this.map.removeLayer('discovery-zones-outline-' + this.uniqueId);
    this.map.removeSource('discovery-zones-' + this.uniqueId);
  }
}
